/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


(() => {
  if (window.dlCollectionLoadMore) return;
  window.dlCollectionLoadMore = true;
  document.addEventListener('click', async (event) => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('[data-dl-load-more-button]');
    if (!button || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const control = button.closest('[data-dl-load-more]');
    const section = control?.closest('[data-section-type="collection"]');
    const list = section?.querySelector('.product-list--collection');
    if (!control || !section || !list) return;
    event.preventDefault();
    if (control.dataset.loading === 'true') return;
    control.dataset.loading = 'true';
    control.setAttribute('aria-busy', 'true');
    button.setAttribute('aria-disabled', 'true');
    const label = button.textContent;
    button.textContent = control.dataset.loadingLabel;
    const error = control.querySelector('.dl-load-more__error');
    error.hidden = true;
    try {
      const url = new URL(button.href, location.origin);
      url.searchParams.set('section_id', section.dataset.sectionId);
      const response = await fetch(url, { credentials: 'same-origin' });
      if (!response.ok) throw new Error('Request failed');
      const page = new DOMParser().parseFromString(await response.text(), 'text/html');
      const nextList = page.querySelector('.product-list--collection');
      const nextControl = page.querySelector('[data-dl-load-more]');
      if (!nextList || !nextControl || nextList.children.length === 0) throw new Error('No products returned');
      if (!control.isConnected) return;
      const additions = Array.from(nextList.children);
      const nextButton = nextControl.querySelector('[data-dl-load-more-button]');
      list.append(...additions);
      control.dataset.shown = nextControl.dataset.shown;
      control.dataset.total = nextControl.dataset.total;
      control.querySelector('.dl-load-more__count').textContent = nextControl.querySelector('.dl-load-more__count').textContent;
      control.querySelector('.dl-load-more__track span').style.width = nextControl.querySelector('.dl-load-more__track span').style.width;
      section.querySelectorAll('.collection__showing-count, .collection__products-count-showing').forEach((item) => {
        item.textContent = nextControl.dataset.showingLabel;
      });
      if (nextButton) {
        button.href = nextButton.href;
      } else {
        button.remove();
      }
      additions[0].querySelector('a[href]')?.focus({ preventScroll: true });
      document.dispatchEvent(new CustomEvent('collection:products:appended', { detail: { sectionId: section.dataset.sectionId } }));
    } catch (failure) {
      if (control.isConnected) {
        error.textContent = control.dataset.errorLabel;
        error.hidden = false;
      }
    } finally {
      control.dataset.loading = 'false';
      control.removeAttribute('aria-busy');
      button.removeAttribute('aria-disabled');
      button.textContent = label;
    }
  });
})();

// Brand descriptions: show the collapse control after the expanded text.
document.addEventListener('click', function(event) {
  var button = event.target.closest('[data-dl-brand-close]');
  if (!button) return;
  var details = button.closest('details[data-dl-brand-more]');
  if (!details) return;
  details.open = false;
  var summary = details.querySelector('summary');
  if (summary) {
    summary.focus({preventScroll: true});
    summary.scrollIntoView({block: 'nearest'});
  }
});
document.addEventListener('toggle', function(event) {
  var details = event.target;
  if (!details.matches || !details.matches('details[data-dl-brand-more]') || !details.open) return;
  var content = details.querySelector(':scope > div');
  if (content) content.focus({preventScroll: true});
}, true);
